import Game from '../../../Game';
import BasePopupHandler, { IBasePopupParams } from './BasePopupHandler';
import GameObject from '../../../GameObject/GameObject';
import BaseUISystem from '../BaseUISystem';
import { IRewardData } from '../../../Utility/RewardHelper';
import Element from '../../../Prototype/UI/Element';
import UIImageComponent from '../../../Component/UI/Image';
import UITextComponent from '../../../Component/UI/Text';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import { AD_COINS_REWARD } from '../../../Constants/Ads';
import UIItem from '../../../Prototype/UI/UIItem';
import Point from '../../../Utility/Point';

import { GameScene } from '../../../State/Game/GameScene';
import { PopupID } from '../../../State/UI/PopupID';

export enum InfoMenuType {
    NO_ADS = 'noAds',
    COIN_REWARD = 'coinReward',
    SUBSCRIBE = 'subscribe',
    ERROR = 'error',
}

export default class InfoMenuHandler extends BasePopupHandler {
    private type: InfoMenuType;
    private _onSubmit: () => boolean | void;
    private _onClose: () => boolean | void;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.INFO_MENU, uiSystem);
    }

    protected createPopup(params?: IBasePopupParams): void {
        this.underlayParams.cacheKey = 'splash_harvest';
        this.submitBtnParams.text.textLocalizationKey = 'Return';

        super.createPopup({
            buttons: [this.closeBtnParams, this.submitBtnParams],
            title: 'Error',
        });
    }

    public onShow(params: any): void {
        this._onSubmit = null;
        this._onClose = null;

        switch (params.type) {
            case InfoMenuType.COIN_REWARD:
                this.showCoinRewardInfo(params.reward);
                break;
            case InfoMenuType.NO_ADS:
                this.showNoAdsInfo();
                break;
            case InfoMenuType.SUBSCRIBE:
                this.showSubscribeInfo();
                break;
            case InfoMenuType.ERROR:
                this.showErrorInfo(params.error);
                break;
        }
        super.onShow(params);
    }

    protected onSubmit(): void {
        this.closePopup();
        if (this._onSubmit) this._onSubmit();
    }
    protected onClose(): void {
        this.closePopup();
        if (this._onClose) this._onClose();
    }

    protected showCoinRewardInfo(reward: IRewardData): void {
        this.background.addChild(
            UIItem.createImage({
                ...this.underlayParams,
                cacheKey: 'get_coins_back',
            })
        );

        this.background.addChild(this.submitBtn);
        this.title = Game.locale.getText('Congratulations');
        // underlay.getComponent(UIImageComponent).texture = 'get_coins_back';

        this.submitBtn.getComponentsInChildren(UITextComponent)[0].text = Game.locale.getText('Great');
        this.submitBtn.button.getComponentsInChildren(UIImageComponent)[0].texture = 'button_medium_green';

        const description: Element = GameObject.Instantiate(Element, {
            name: 'info_text',
            layout: {
                anchors: [0.5, 0.27, 0.5, 0.27],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
            components: [
                {
                    type: 'text',
                    data: {
                        style: {
                            ...Game.style.getStyle('popup.green_btn'),
                            fontSize: 50,
                            align: 'center',
                        },
                        textLocalizationKey: '1000Coins',
                    },
                },
            ],
        });

        // Not sure why this is needed but it is?
        description.getComponent(UITextComponent).style.align = 'center';
        description.getComponent(UITextComponent).bounds = new Point(640, 140);
        this.background.findChildByName(this.underlayParams.name).addChild(description);

        const giveReward: () => void = () => {
            PlayerActions.receiveRewards({
                rewards: [AD_COINS_REWARD],
                queueTask: Game.store.getState().activeScene.result === GameScene.WORLD,
            });
        };

        this._onClose = giveReward.bind(this);
        this._onSubmit = giveReward.bind(this);
    }
    protected showNoAdsInfo(): void {
        this.background.addChild(
            UIItem.createImage({
                ...this.underlayParams,
                cacheKey: 'no_ads_back',
            })
        );
        const submitBtnText: UITextComponent = this.submitBtn.text.getComponent(UITextComponent);

        this.title = Game.locale.getText('NoAds');

        submitBtnText.text = Game.locale.getText('Return');
        this.submitBtn.button.getComponentsInChildren(UIImageComponent)[0].texture = 'button_medium_green';
        this.background.addChild(this.submitBtn);

        const description: Element = GameObject.Instantiate(Element, {
            name: 'info_text',
            layout: {
                anchors: [0.5, 0.45, 0.5, 0.45],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
            components: [
                {
                    type: 'text',
                    data: {
                        style: {
                            ...Game.style.getStyle('popup.blue_btn'),
                            fontSize: 35,
                            align: 'center',
                        },
                        textLocalizationKey: 'WatchedAllAds',
                    },
                },
            ],
        });
        description.getComponent(UITextComponent).bounds = new Point(640, 140);
        // Not sure why this is needed but it is?
        description.getComponent(UITextComponent).style.align = 'center';

        this.background.findChildByName(this.underlayParams.name).addChild(description);
    }

    protected showSubscribeInfo(): void {
        this.background.addChild(
            UIItem.createImage({
                ...this.underlayParams,
                layout: {
                    anchors: [0.5, 0.44, 0.5, 0.44],
                    pivot: [0.5, 0.5],
                    offsets: [0, 0, 0, 0],
                    scale: [1, 1],
                },
                cacheKey: 'UI_Subscribe_banner',
            })
        );

        this.title = Game.locale.getText('DailyGifts');

        this.submitBtn.getComponentsInChildren(UITextComponent)[0].text = Game.locale.getText('Subscribe');
        this.submitBtn.button.getComponentsInChildren(UIImageComponent)[0].texture = 'button_medium_green';

        this.background.addChild(this.submitBtn);
        const description: Element = GameObject.Instantiate(Element, {
            name: 'info_text',
            layout: {
                anchors: [0.5, 0.74, 0.5, 0.74],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
            components: [
                {
                    type: 'text',
                    data: {
                        style: {
                            font: 'FrancoisOne',
                            fill: '#bb3c2f',
                            fontSize: '30px',
                        },
                        textLocalizationKey: 'SubscribeMessage',
                    },
                },
            ],
        });
        this.background.addChild(description);

        // Not sure why this is needed but it is?
        description.getComponent(UITextComponent).style.align = 'center';
    }
    protected showErrorInfo(error: string): void {
        console.warn(error);
        this.title = 'Error';

        // Error text
        const description: Element = GameObject.Instantiate(Element, {
            name: 'info_text',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
            },
            components: [
                {
                    type: 'text',
                    data: {
                        style: {
                            ...Game.style.getStyle('popup.text'),
                            fontSize: 150,
                            align: 'center',
                        },
                        textLocalizationKey: '',
                        bounds: [400, 120],
                    },
                },
            ],
            children: [
                {
                    name: 'error_icon',
                    layout: {
                        anchors: [1, 0.5, 1, 0.5],
                        pivot: [0, 0.45],
                        offsets: [-10, 0, -10, 0],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'popup_goal_fail',
                            },
                        },
                    ],
                },
            ],
        });
        description.getComponent(UITextComponent).text = error;
        this.background.addChild(description);

        const buttonText: UITextComponent = this.submitBtn.getComponentsInChildren(UITextComponent)[0];
        buttonText.text = Game.locale.getText('Return');
        buttonText.style = Game.style.getStyle('popup.red_btn');
        this.submitBtn.button.getComponentsInChildren(UIImageComponent)[0].texture = 'button_medium_red';

        const character: Element = GameObject.Instantiate(Element, {
            name: 'character',
            layout: {
                anchors: [0, 0.5, 0, 0.5],
                pivot: [0.5, 0.5],
                offsets: [40, -80, 40, -80],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'character_failed_1',
                    },
                },
            ],
        });
        this.background.addChild(character);

        this.background.addChild(this.submitBtn);
    }
}
